var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThrashBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0H5.33333C4.35289 0 3.55556 0.8073 3.55556 1.8V3.6H0V5.4H1.77778V16.2C1.77778 17.1927 2.57511 18 3.55556 18H12.4444C13.4249 18 14.2222 17.1927 14.2222 16.2V5.4H16V3.6H12.4444V1.8C12.4444 0.8073 11.6471 0 10.6667 0ZM5.33333 1.8H10.6667V3.6H5.33333V1.8ZM3.55556 16.2H12.4444V5.4H11.5556H4.44444H3.55556V16.2Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThrashBlack);
export default __webpack_public_path__ + "static/media/ic-thrash-black.1e2d0e53.svg";
export { ForwardRef as ReactComponent };